/**
 * WAV Encoder
 * Encodes PCM audio data to WAV format
 */

function writeString(view, offset, string) {
   for (let i = 0; i < string.length; i++) {
      view.setUint8(offset + i, string.charCodeAt(i));
   }
}

export function encodeWAV(samples, channels = 1, sampleRate = 44100, bitsPerSample = 16) {
   const bytesPerSample = bitsPerSample / 8;
   const blockAlign = channels * bytesPerSample;
   const byteRate = sampleRate * blockAlign;
   const dataSize = samples.length * bytesPerSample;
   const buffer = new ArrayBuffer(44 + dataSize);
   const view = new DataView(buffer);

   writeString(view, 0, 'RIFF');
   view.setUint32(4, 36 + dataSize, true);
   writeString(view, 8, 'WAVE');

   writeString(view, 12, 'fmt ');
   view.setUint32(16, 16, true);
   view.setUint16(20, 1, true);
   view.setUint16(22, channels, true);
   view.setUint32(24, sampleRate, true);
   view.setUint32(28, byteRate, true);
   view.setUint16(32, blockAlign, true);
   view.setUint16(34, bitsPerSample, true);

   writeString(view, 36, 'data');
   view.setUint32(40, dataSize, true);

   const sampleData = new DataView(buffer, 44, dataSize);

   if (bitsPerSample === 16) {
      for (let i = 0; i < samples.length; i++) {
         const sample = Math.max(-1.0, Math.min(1.0, samples[i]));
         const intSample = sample < 0 ? sample * 0x8000 : sample * 0x7FFF;
         sampleData.setInt16(i * 2, intSample, true);
      }
   } else if (bitsPerSample === 24) {
      for (let i = 0; i < samples.length; i++) {
         const sample = Math.max(-1.0, Math.min(1.0, samples[i]));
         const intSample = sample < 0 ? sample * 0x800000 : sample * 0x7FFFFF;
         sampleData.setUint8(i * 3, intSample & 0xFF);
         sampleData.setUint8(i * 3 + 1, (intSample >> 8) & 0xFF);
         sampleData.setUint8(i * 3 + 2, (intSample >> 16) & 0xFF);
      }
   } else {
      throw new Error(`Unsupported bits per sample: ${bitsPerSample}`);
   }

   return buffer;
}

export function createWAVFromREX2(rexData, samples) {
   const sampleRate = rexData.info?.sampleRate || rexData.global?.sampleRate || 44100;
   const channels = rexData.info?.channels || rexData.global?.channels || 1;
   const bitDepth = rexData.info?.bitDepth || 16;

   return encodeWAV(samples, channels, sampleRate, bitDepth);
}

export function wavBufferToBlob(wavBuffer) {
   return new Blob([wavBuffer], { type: 'audio/wav' });
}

export function createWAVDownloadURL(wavBuffer, filename = 'output.wav') {
   const blob = wavBufferToBlob(wavBuffer);
   return URL.createObjectURL(blob);
}
